import React, { memo, useCallback } from 'react'

import Checkbox from '../../../../Mantine/Checkbox'

import * as S from './styles'

const getGridTemplateRows = (length) => {
  if (length > 16) return Math.ceil(length / 4)
  if (length > 8) return Math.ceil(length / 3)
  if (length > 4) return Math.ceil(length / 2)
  return length
}

const CheckboxFilter = ({ nome, localFilters, setLocalFilters, opcoes }) => {
  const handleChange = useCallback(
    (checked, value) => {
      setLocalFilters((prev) => ({
        ...prev,
        [nome]: checked
          ? [...(prev[nome] || []), value]
          : (prev[nome] || []).filter((f) => f !== value)
      }))
    },
    [setLocalFilters, nome]
  )

  return (
    <S.CheckboxAndRadioWrapper
      isOperadora={nome === 'OPERADORA'}
      gridTemplateRows={getGridTemplateRows((opcoes[nome] || []).length)}
    >
      {opcoes[nome]?.map((opcao) => (
        <Checkbox
          key={opcao.value}
          label={opcao.label}
          checked={localFilters[nome]?.includes(opcao.value) || false}
          onChange={(event) =>
            handleChange(event.currentTarget.checked, opcao.value)
          }
        />
      ))}
    </S.CheckboxAndRadioWrapper>
  )
}

export default memo(CheckboxFilter)
